import gridCss from "../../utilities/Grid.js";
import { Card } from "primereact/card";
import "./style.css";
import { useEffect, useRef, useState } from "react";

const CardSeplagScrol = (props) => {
  const scrollContainerRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState(props.maxHeight || "600px");

  function colClasseCss() {
    let classeCss = gridCss(props.cols ? props.cols : "12");
    return classeCss;
  }


  function title() {
    if (props.title) {
      return (
        <div className="p-col-12">
          {props.handleVoltar ? (
            <div className="p-grid" style={{ cursor: "pointer", alignItems: "center" }} onClick={props.handleVoltar}>
              <div className="p-col-12 p-md-6 p-lg-4 p-xl-4">
                <div style={{ display: "flex" }}>
                  <i className="pi pi-angle-left" style={{ fontSize: "2rem", margin: "1.5rem 0 1rem 0" }} />
                  <h5 style={{ flex: 1 }}>
                    <strong>{props.title}</strong>
                  </h5>
                </div>
              </div>
              <div className="p-col-12 p-md-6">{props.legenda && props.legenda()}</div>
            </div>
          ) : (
            <h5>
              <strong>{props.title}</strong>
              {props.legenda && props.legenda()}
            </h5>
          )}
          <hr />
        </div>
      );
    } else {
      return <></>;
    }
  }

  return (
    <div className={colClasseCss()} style={{ width: `${props.propWidth}` }}>
      <Card className={props.cardHeaderClassNames}>
        <div className="p-grid">
          {title()}
          {/* Adicione uma div com scroll */}
          <div
            ref={scrollContainerRef}
            className="scroll-container"
            style={{ maxHeight: maxHeight, overflowY: "auto", overflowX: "hidden" }}
          >
            {props.children}
          </div>
        </div>
      </Card>
    </div>
  );
};

export default CardSeplagScrol;
